import Vue from 'vue'
import App from './app.vue'
import router from './router'
import './router/router-navigation-guard'
import ElementUI from 'element-ui'
import VueI18n from 'vue-i18n'
import { lcn } from './lang/zh'
import { len } from './lang/en'
import enLocale from 'element-ui/lib/locale/lang/en'
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
import 'element-ui/lib/theme-chalk/index.css' // 默认主题
import './assets/css/icon.css'
import './components/common/directives'
import './assets/iconfont/iconfont'
import '@/utils/flexible'

import { dateFormat, formatFileSize } from '@/utils'
import store from '@/store/index'

const requireAll = (requireContext) => requireContext.keys().map(requireContext)
const req = require.context('@/assets/icons', false, /\.svg$/)

requireAll(req)

Vue.config.productionTip = false
Vue.use(VueI18n)
ElementUI.Dialog.props.closeOnClickModal.default = false
Vue.use(ElementUI, {
    size: 'small',
    i18n: (key, value) => i18n.t(key, value)
})
Vue.filter('fileSize', formatFileSize)
Vue.filter('formatDate', (value) => {
    if (value != null) {
        return dateFormat(new Date(value), 'yyyy-MM-dd')
    } else {
        return value
    }
})
Vue.filter('formatDateTime', (value) => {
    if (value != null) {
        return dateFormat(new Date(value), 'yyyy-MM-dd hh:mm:ss')
    } else {
        return value
    }
})

Vue.filter('formatNumThousandths', (num) => {
    if (typeof num !== 'number') return ''
    const numFixed2 = num.toFixed(2)
    const res = numFixed2.toString().replace(/\d+/, (n) =>
        // 先提取整数部分
        n.replace(/(\d)(?=(\d{3})+$)/g, ($1) => `${$1},`)
    )
    return res
})

const i18n = new VueI18n({
    locale: localStorage.getItem('lang') || 'zh',
    messages: {
        zh: { ...lcn, ...zhLocale },
        en: { ...len, ...enLocale }
    },
    silentTranslationWarn: true // 去除国际化警告
})
window.vm = new Vue({
    i18n,
    store
})
new Vue({
    router,
    i18n,
    store,
    render: (h) => h(App)
}).$mount('#app')
